import { render, staticRenderFns } from "./Sessions2.vue?vue&type=template&id=7ba23a7d"
import script from "./Sessions2.vue?vue&type=script&lang=js"
export * from "./Sessions2.vue?vue&type=script&lang=js"
import style0 from "./Sessions2.vue?vue&type=style&index=0&id=7ba23a7d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports